const ourProcessData = [
    {
        id:"1",
        title:"Initial Consultation",
        details:"We begin with a comprehensive consultation to understand your business needs and objectives."
    },
    {
        id:"2",
        title:"Strategy & Planning",
        details:"Next, we develop a comprehensive roadmap tailored to your specific needs. We outline the timeline, key milestones, and a clear path to success."
    },
    {
        id:"3",
        title:"Design & Development",
        details:"Our team brings the plan to life, focusing on quality and innovation. We create a solution that is both functional and aesthetically exceptional."
    },
    {
        id:"4",
        title:"Review & Refinement",
        details:"We present our work for your feedback, ensuring it aligns perfectly with your vision. This collaborative step allows us to refine and perfect every detail."
    },
    {
        id:"5",
        title:"Launch & Delivery",
        details:"Your new solution goes live, ready to make an impact. We ensure a smooth and seamless launch, providing everything you need to get started."
    },
    {
        id:"6",
        title:"Ongoing Support",
        details:"Our partnership doesn't end at launch; we are here for your continued success. We offer maintenance and support to ensure your solution performs optimally."
    },
]

export default ourProcessData;